import styled from 'styled-components';
import UserLogoIcon from 'js/components/core/Icons/UserLogoIcon';

export default styled(UserLogoIcon)`
  display: block;
  width: 40px;
  margin: 0 auto 1rem;
`;
